module.exports = __webpack_public_path__ + "74353502665c2d3b7780ca9309663400.svg";